import axios from 'axios';
import { getApplyAccessToken, getApplyRefreshToken, clearApplyAuth } from '@/utils/applyAuth';

// 在线留言申请人侧独立实例：绝不走 utils/request.js 的全局拦截器（同 memberApply.js 的设计）。
// 留言与会员申请共用 apply 身份（微信扫码授权签发），与管理端/用户端登录态完全隔离。
const BASE_URL = '/api';

const raw = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' }
});

raw.interceptors.request.use(config => {
  const token = getApplyAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let refreshing = null;

function redirectToAuth() {
  clearApplyAuth();
  window.location.href = '/#/service?needAuth=1';
}

async function refreshApplyToken() {
  const refreshToken = getApplyRefreshToken();
  if (!refreshToken) return null;
  const res = await axios.post(`${BASE_URL}/auth/refresh-token`, { token: refreshToken }, {
    headers: { 'Content-Type': 'application/json' }
  });
  if (res.data && res.data.success && res.data.data) {
    const { accessToken } = res.data.data;
    localStorage.setItem('applyAccessToken', accessToken);
    return accessToken;
  }
  return null;
}

raw.interceptors.response.use(
  response => {
    if (response.data && response.data.success) {
      return response.data;
    }
    throw response.data;
  },
  async error => {
    const status = error.response && error.response.status;
    const original = error.config || {};

    if (status === 401 && !original._retry) {
      original._retry = true;
      try {
        if (!refreshing) {
          refreshing = refreshApplyToken().finally(() => { refreshing = null; });
        }
        const newToken = await refreshing;
        if (newToken) {
          original.headers.Authorization = `Bearer ${newToken}`;
          return raw(original);
        }
      } catch (e) {
        // 续期失败，走下面的重新授权
      }
      redirectToAuth();
      throw error;
    }

    throw error;
  }
);

export default {
  /** 提交留言（需微信授权，apply 身份） */
  submit(data) {
    return raw.post('/contact/client/submit', data);
  },

  /** 我的留言（按 unionid 归集，含状态） */
  my() {
    return raw.get('/contact/client/my');
  }
};
